import { render, staticRenderFns } from "./DeletePower.vue?vue&type=template&id=0cc832a3&scoped=true&"
import script from "./DeletePower.vue?vue&type=script&lang=js&"
export * from "./DeletePower.vue?vue&type=script&lang=js&"
import style0 from "./DeletePower.vue?vue&type=style&index=0&id=0cc832a3&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0cc832a3",
  null
  
)

export default component.exports